export default function pluralizeStringUtil (str, count) {
  return count !== 1 ? str + 's' : str
}
